import { ActionsMenu } from '../ActionsMenu';
import {
  StyledHeader,
} from './AppHeader.styles';
import { VerticalDivider } from 'shared/components';
import { HeaderNotificationContainer } from '../Notifications/HeaderNotificationContainer';

export function AppHeader() {
  return (
    <StyledHeader>
      <div className="actions-container">
        <HeaderNotificationContainer />
        <VerticalDivider />
        <ActionsMenu />
      </div>
    </StyledHeader>
  );
}
